import React, { createContext, useContext, useEffect, useState } from "react";
const Context = createContext([]);
export function LangProvider({ children, currentLang }) {
    const [lang, setLang] = useState(() => {
        if (currentLang)
            return currentLang;
        if (typeof document === 'undefined')
            return 'lt';
        return (document === null || document === void 0 ? void 0 : document.documentElement.lang) || 'lt';
    });
    const [urlTranslates, setUrlTranslates] = useState({});
    useEffect(() => {
        if (lang === document.documentElement.lang)
            return;
        document.documentElement.lang = lang || 'lt';
    }, [lang]);
    return (React.createElement(Context.Provider, { value: [lang, setLang, urlTranslates, setUrlTranslates] }, children));
}
export function useLangContext() {
    return useContext(Context);
}
